export default "__VITE_ASSET__Du6q$sgm__"